import { Button, Flex, Paper, Text, Loader, Switch } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../hooks";
import { RootState } from "../store";
import {
  displayErrorMessage,
  displayServerErrorMessage,
} from "../shared/ErrorMessage";
import { initialize, updateField } from "../slices/form/editHost";
import { useEffect } from "react";
import { Perm } from "../slices/types";
import { SaveHostRequest, useSaveHostMutation } from "../slices/api/ventsApi";
import { UserPermWithOwnerSegmentedControl } from "../shared/components/UserPermSegmentedControl";
import { useAuth } from "../authentication/AuthProvider";

interface Props {
  ventId: string;
  hostName: string;
  hostEmail: string;
  updateTime: string;
  hostPerm: Perm;
  hostEmailOptOut: boolean;
  userPerm: Perm;
  onClose: () => void;
}
const EditHost = (props: Props) => {
  const { data, hasChanges } = useAppSelector(
    (state: RootState) => state.editHostForm
  );
  const [saveHost] = useSaveHostMutation();
  const authUser = useAuth();

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      initialize({
        perm: props.hostPerm,
        emailOptOut: props.hostEmailOptOut,
      })
    );
  }, []);

  const handleSave = async () => {
    if (data === undefined) {
      console.error("undefined");
      return;
    }
    const request: SaveHostRequest = {
      ventId: props.ventId,
      hostEmail: props.hostEmail,
      perm: data.perm,
      emailOptOut: data.emailOptOut,
      updateTime: props.updateTime,
    };

    try {
      await saveHost(request).unwrap();
      props.onClose();
    } catch (error) {
      displayServerErrorMessage(error);
    }
  };

  if (!data) {
    return <Loader color="blue" />;
  }

  const isUserThisHost = authUser.user?.email === props.hostEmail;
  return (
    <>
      <Paper>
        <Text size="lg">{`Edit Host for ${props.hostName}`}</Text>
        <UserPermWithOwnerSegmentedControl
          label={
            props.userPerm === "o"
              ? "Permissions (owner's permission cannot be changed)"
              : "Permissions"
          }
          disabled={isUserThisHost || props.userPerm !== "o"}
          value={data.perm}
          onChange={(value) => {
            if (isUserThisHost) {
              displayErrorMessage("You cannot change your own permissions.");
              return;
            }
            dispatch(
              updateField({
                field: "perm",
                value: value,
              })
            );
          }}
        />
        <Switch
          label="Opt out of event emails"
          mt="lg"
          checked={data.emailOptOut}
          onChange={(event) =>
            dispatch(
              updateField({
                field: "emailOptOut",
                value: event.currentTarget.checked,
              })
            )
          }
        />
        <Flex justify="flex-end">
          <Button mt="md" mr="md" onClick={props.onClose}>
            Cancel
          </Button>
          <Button mt="md" onClick={handleSave} disabled={!hasChanges}>
            Save
          </Button>
        </Flex>
      </Paper>
    </>
  );
};

export default EditHost;
